<template>
<div class="main-body">
  <b-alert
    dismissible
    :show="showDismissibleAlert"
    :variant="alertVariant"
    @dismissed="showDismissibleAlert=false">{{ alertMessage }}</b-alert>
    <form>
      <div class="card">
          <div class="card-body">
              <div class="row">
                  <div class="col-sm-5">
                      <h4 class="card-title mb-0">
                        Pending Order <small class="text-muted"> edit</small>
                      </h4>
                  </div><!--col-->
              </div><!--row-->

              <div class="row mt-4">
                  <div class="col">
                      <div class="form-group row">
                        <label for="reference_no" class="col-sm-2 col-form-label">{{ $t('delivery.label.reference_no') }}</label>
                        <div class="col-sm-3">
                          {{ pendingOrder.reference_no }}
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="courier_id" class="col-sm-2 col-form-label">{{ $t('delivery.label.service_name') }}</label>
                        <div class="col-sm-3">
                          <select class="form-control" v-model="pendingOrder.service_code">
                            <option :value="pendingOrder.service_code">{{ pendingOrder.service_code }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="company" class="col-sm-2 col-form-label">{{ $t('delivery.label.company') }}</label>
                        <div class="col-sm-4">
                          <input v-model="pendingOrder.company" type="text" name="company" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="shipment_content" class="col-sm-2 col-form-label">{{ $t('delivery.label.shipment_content') }}</label>
                        <div class="col-sm-6" v-bind:class="{'form-group--error': $v.pendingOrder.shipment_content.$error }">
                          <input v-model="pendingOrder.shipment_content" type="text" name="shipment_content" class="form-control" v-bind:class="containsErrorKey('shipment_content')"/>
                          <div role="alert" aria-live="assertive" aria-atomic="true" class="invalid-feedback d-block">{{ validFailed.shipment_content }}</div>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="email" class="col-sm-2 col-form-label">{{ $t('delivery.label.email') }}</label>
                        <div class="col-sm-4" v-bind:class="{'form-group--error': $v.pendingOrder.email.$error }">
                          <input v-model="pendingOrder.email" type="text" name="email" class="form-control" v-bind:class="containsErrorKey('email')"/>
                          <div role="alert" aria-live="assertive" aria-atomic="true" class="invalid-feedback d-block">{{ validFailed.email }}</div>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="delivery_name" class="col-sm-2 col-form-label">{{ $t('delivery.label.delivery_name') }}</label>
                        <div class="col-sm-4" v-bind:class="{'form-group--error': $v.pendingOrder.delivery_name.$error }">
                          <input v-model="pendingOrder.delivery_name" type="text" class="form-control" v-bind:class="containsErrorKey('delivery_name')"/>
                          <div role="alert" aria-live="assertive" aria-atomic="true" class="invalid-feedback d-block">{{ validFailed.delivery_name }}</div>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="address" class="col-sm-2 col-form-label">{{ $t('delivery.label.address') }}</label>
                        <div class="col-sm-6" v-bind:class="{'form-group--error': $v.pendingOrder.address.$error }">
                          <input v-model="pendingOrder.address" type="text" name="address" class="form-control" v-bind:class="containsErrorKey('address')"/>
                          <div role="alert" aria-live="assertive" aria-atomic="true" class="invalid-feedback d-block">{{ validFailed.address }}</div>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="address1" class="col-sm-2 col-form-label">{{ $t('delivery.label.address1') }}</label>
                        <div class="col-sm-6">
                          <input v-model="pendingOrder.address1" type="text" name="address1" class="form-control"/>
                          <div role="alert" aria-live="assertive" aria-atomic="true" class="invalid-feedback d-block">{{ validFailed.address1 }}</div>
                        </div>
                      </div>
                       <div class="form-group row">
                        <label for="address2" class="col-sm-2 col-form-label">{{ $t('delivery.label.address2') }}</label>
                        <div class="col-sm-6">
                          <input v-model="pendingOrder.address2" type="text" name="address2" class="form-control"/>
                          <div role="alert" aria-live="assertive" aria-atomic="true" class="invalid-feedback d-block">{{ validFailed.address2 }}</div>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="country" class="col-sm-2 col-form-label">{{ $t('delivery.label.country') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.pendingOrder.country.$error }">
                          <input v-model="pendingOrder.country" type="text" name="country" class="form-control" v-bind:class="containsErrorKey('country')"/>
                          <div role="alert" aria-live="assertive" aria-atomic="true" class="invalid-feedback d-block">{{ validFailed.country }}</div>
                        </div>
                        <label for="district" class="col-sm-2 col-form-label">{{ $t('delivery.label.district') }}</label>
                        <div class="col-sm-3">
                          <input v-model="pendingOrder.district" type="text" name="postal" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="city" class="col-sm-2 col-form-label">{{ $t('delivery.label.city') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.pendingOrder.city.$error }">
                          <input v-model="pendingOrder.city" type="text" name="city" class="form-control" />
                        </div>
                        <label for="state" class="col-sm-2 col-form-label">{{ $t('delivery.label.state') }}</label>
                        <div class="col-sm-3">
                          <input v-model="pendingOrder.state" type="text" name="state" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="postal" class="col-sm-2 col-form-label">{{ $t('delivery.label.postal_code') }}</label>
                        <div class="col-sm-3">
                          <input v-model="pendingOrder.postal" type="text" name="postal" class="form-control" v-bind:class="containsErrorKey('postal')"/>
                          <div role="alert" aria-live="assertive" aria-atomic="true" class="invalid-feedback d-block">{{ validFailed.postal }}</div>
                        </div>
                        <label for="phone" class="col-sm-2 col-form-label">{{ $t('delivery.label.phone') }}</label>
                        <div class="col-sm-3">
                          <input v-model="pendingOrder.phone" type="text" name="phone" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="product_type" class="col-sm-2 col-form-label">{{ $t('delivery.label.product_type') }}</label>
                        <div class="col-sm-6">
                          <div class="form-check form-check-inline">
                            <input v-model="pendingOrder.product_type" class="form-check-input" checked="checked" type="radio" name="product_type" id="inlineRadio1" value="1">
                            <label class="form-check-label" for="inlineRadio1">Package</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input v-model="pendingOrder.product_type" class="form-check-input" type="radio" name="product_type" id="inlineRadio2" value="2">
                            <label class="form-check-label" for="inlineRadio2">PAK袋</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input v-model="pendingOrder.product_type" class="form-check-input" type="radio" name="product_type" id="inlineRadio3" value="3">
                            <label class="form-check-label" for="inlineRadio3">Letters</label>
                          </div>
                           <div class="form-check form-check-inline">
                           </div>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="package_num" class="col-sm-2 col-form-label">{{ $t('delivery.label.package_num') }}</label>
                        <div class="col-sm-2">
                          <input v-model="pendingOrder.package_num" type="number" name="package_num" class="form-control" />
                        </div>
                        <label for="battery" class="col-sm-2 col-form-label">{{ $t('delivery.label.battery') }}</label>
                        <div class="col-sm-2" v-bind:class="{'form-group--error': $v.pendingOrder.battery.$error }">
                          <select v-model="pendingOrder.battery" class="form-control" required>
                            <option value="0">No</option>
                            <option value="1">Yes</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="declared_value" class="col-sm-2 col-form-label">{{ $t('delivery.label.declared_value') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.pendingOrder.declared_value.$error }">
                          <input v-model="pendingOrder.declared_value" type="text" name="declared_value" class="form-control" v-bind:class="containsErrorKey('declared_value')"/>
                          <div role="alert" aria-live="assertive" aria-atomic="true" class="invalid-feedback d-block">{{ validFailed.declared_value }}</div>
                        </div>
                        <label for="declared_currency" class="col-sm-2 col-form-label">{{ $t('delivery.label.declared_currency') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.pendingOrder.declared_currency.$error }">
                          <input v-model="pendingOrder.declared_currency" type="text" name="declared_currency" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="incoterm" class="col-sm-2 col-form-label">{{ $t('delivery.label.incoterm') }}</label>
                        <div class="col-sm-4" v-bind:class="{'form-group--error': $v.pendingOrder.incoterm.$error }">
                          <select v-model="pendingOrder.incoterm" class="form-control" required>
                            <option value="">-- {{ $t('general.input.please_select_a_incoterm') }} --</option>
                            <option v-for="(incoterm, index) in incoterms" :value="incoterm.incoterm" :key="index">{{incoterm.incoterm }} </option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="insurance_value" class="col-sm-2 col-form-label">{{ $t('delivery.label.insurance_value') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.pendingOrder.insurance_value.$error }">
                          <input v-model="pendingOrder.insurance_value" type="text" name="insurance_value" class="form-control" v-bind:class="containsErrorKey('insurance_value')"/>
                          <div role="alert" aria-live="assertive" aria-atomic="true" class="invalid-feedback d-block">{{ validFailed.insurance_value }}</div>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="weight" class="col-sm-2 col-form-label">{{ $t('delivery.label.weight') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.pendingOrder.weight.$error }">
                          <input v-model="pendingOrder.weight" type="text" name="weight" class="form-control" v-bind:class="containsErrorKey('weight')"/>
                          <div role="alert" aria-live="assertive" aria-atomic="true" class="invalid-feedback d-block">{{ validFailed.weight }}</div>
                        </div>
                        <label for="weight_unit" class="col-sm-2 col-form-label">{{ $t('delivery.label.weight_unit') }}</label>
                        <div class="col-sm-3">
                          <input v-model="pendingOrder.weight_unit" type="text" readonly="" name="weight_unit" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="height" class="col-sm-2 col-form-label">{{ $t('delivery.label.height') }}</label>
                        <div class="col-sm-3">
                          <input v-model="pendingOrder.height" type="text" name="height" class="form-control" />
                        </div>
                        <label for="width" class="col-sm-2 col-form-label">{{ $t('delivery.label.width') }}</label>
                        <div class="col-sm-3">
                          <input v-model="pendingOrder.width" type="text" name="width" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="length" class="col-sm-2 col-form-label">{{ $t('delivery.label.length') }}</label>
                        <div class="col-sm-3">
                          <input v-model="pendingOrder.length" type="text" name="length" class="form-control" />
                        </div>
                        <label for="dimension_uom" class="col-sm-2 col-form-label">{{ $t('delivery.label.dimension_uom') }}</label>
                        <div class="col-sm-3">
                          <input v-model="pendingOrder.dimension_uom" readonly="" type="text" name="dimension_uom" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="remark" class="col-sm-2 col-form-label">{{ $t('delivery.label.remark') }}</label>
                        <div class="col-sm-6">
                          <input v-model="pendingOrder.remark" type="text" name="remark" class="form-control" />
                        </div>
                      </div>
                  </div><!--col-->
              </div><!--row-->
              <div class="row mt-4">
                <div class="col">
                  <div class="table-responsive">
                      <table class="table">
                        <thead>
                          <tr>
                            <th>{{ $t('delivery.label_detail.line_no') }}</th>
                            <th>{{ $t('delivery.label_detail.sku') }}</th>
                            <th>{{ $t('delivery.label_detail.product_name') }}</th>
                            <th>{{ $t('delivery.label_detail.description_export') }}</th>
                            <th>{{ $t('delivery.label_detail.description_import') }}</th>
                            <th>{{ $t('delivery.label_detail.country_of_origin') }}</th>
                            <th>{{ $t('delivery.label_detail.quantity') }}</th>
                            <th>{{ $t('delivery.label.weight') }}</th>
                            <th>{{ $t('delivery.label_detail.item_declared_value') }}</th>
                            <th>{{ $t('delivery.label_detail.hscode') }}</th>
                            <th>{{ $t('delivery.label_detail.hsdescription') }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in pendingOrder.items" :key="index">
                            <td>{{ item.line_no }}</td>
                            <td><input v-model="item.sku" type="text" name="remark" class="form-control" /></td>
                            <td><input v-model="item.product_name" type="text" name="product_name" class="form-control" /></td>
                            <td><input v-model="item.description_export" type="text" name="description_export" class="form-control" /></td>
                            <td><input v-model="item.description_import" type="text" name="description_import" class="form-control" /></td>
                            <td><input v-model="item.country_of_origin" type="text" name="country_of_origin" class="form-control" /></td>
                            <td><input v-model="item.quantity" type="text" name="quantity" class="form-control" /></td>
                            <td><input v-model="item.weight" type="text" name="weight" class="form-control" /></td>
                            <td><input v-model="item.item_declared_value" type="text" name="item_declared_value" class="form-control" /></td>
                            <td><input v-model="item.hscode" type="text" name="hscode" class="form-control" /></td>
                            <td><input v-model="item.hsdescription" type="text" name="hsdescription" class="form-control" /></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              <div slot="footer">
                <div class="row">
                    <div class="col-7">
                        <div class="float-left"></div>
                    </div><!--col-->
                    <div class="col-5">
                        <div class="float-right">
                            <b-button type="submit" size="sm" variant="primary" @click.stop.prevent="handleSubmit"><i class="fa fa-dot-circle-o"></i> Submit</b-button>
                        </div>
                    </div><!--col-->
                </div><!--row-->
              </div>
          </div><!--card-body-->
      </div><!--card-->
    </form>
    <div class="card" v-if="pendingOrder.api_failed_message">
      <header class="card-header">
        <div><i classname="fa fa-align-justify"></i> Failed Message From Courier Api</div>
      </header>
      <div class="card-body">
        <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-danger">
           {{ pendingOrder.api_failed_message }}
        </div>
      </div>
    </div>
   <loading-panel v-if="showLoadingPanel"></loading-panel>
  </div>
</template>
<script>
import { required, maxLength, email } from 'vuelidate/lib/validators'
import loadingPanel from '@/components/LoadingPanel'

export default {
  name: 'PendingEdit',
  components: {
    loadingPanel
  },
  beforeCreate () {
    this.axios.get('/delivery/pending/' + this.$route.params.id + '/edit').then(response => {
      // only status in[2, 4] will allow edit
      if (response.data.status === 2 || response.data.status === 4) {
        this.pendingOrder = response.data
        this.incoterms = response.incoterms
        if (this.pendingOrder.valid_failed != null) {
          this.validFailed = JSON.parse(this.pendingOrder.valid_failed)
        }
      } else {
        this.$swal({
          title: this.$t('delivery.label.not_allow_edit'),
          icon: 'warning'
        }).then(() => {
          this.$router.push('/delivery/pending')
        })
      }
    }).catch(error => {
      console.log(error)
    })
  },
  data () {
    return {
      batteryOptions: [
        {
          value: 0,
          name: 'No battery'
        },
        {
          value: 1,
          name: 'battery'
        }
      ],
      pendingOrder: {},
      incoterms: [],
      validFailed: {},
      showLoadingPanel: false,
      showDismissibleAlert: false,
      alertVariant: '',
      alertMessage: '',
      message: ''
    }
  },
  validations: {
    pendingOrder: {
      shipment_content: {
        required
      },
      email: {
        email
      },
      incoterm: {
        required
      },
      delivery_name: {
        required
      },
      address: {
        required
      },
      country: {
        required,
        maxLength: maxLength(2)
      },
      city: {
        required
      },
      postal: {
        required
      },
      battery: {
        required
      },
      declared_value: {
        required
      },
      declared_currency: {
        required
      },
      insurance_value: {
        required
      },
      weight: {
        required
      }
    }
  },
  methods: {
    containsErrorKey (key) {
      let result = Object.keys(this.validFailed).includes(key)
      if (result) {
        return 'is-invalid'
      }
    },
    handleSubmit () {
      this.$v.pendingOrder.$touch()
      if (!this.$v.pendingOrder.$error) {
        // create pendingOrder
        let vm = this
        this.showLoadingPanel = true
        this.axios.put('/delivery/pending/' + this.pendingOrder.id, this.pendingOrder).then(response => {
          this.showLoadingPanel = false
          this.$swal({
            title: vm.$t('delivery.label.update_pending_success'),
            icon: 'success'
          }).then(() => {
            this.$router.push('/delivery/pending')
          })
          this.message = response.data
        }).catch(error => {
          this.showLoadingPanel = false
          if(error.data.validations && Object.keys(error.data.validations).length > 0){
            let  errorMessage = ""
            for(var key of Object.keys(error.data.validations)) {
              errorMessage = key +": "
              error.data.validations[key].forEach(element => {
                errorMessage += element
              });
            }
            this.showAlert('danger', errorMessage)
          }
          if(error.data.message){
              this.showAlert('danger', error.data.message)
          }
        })
      }
    },
    showAlert (alertVariant, message) {
      this.showDismissibleAlert = true
      this.alertVariant = alertVariant
      this.alertMessage = message
    }
  }
}
</script>
